// Lab (lab/iphone-40-no-merge): fills the vertical desktop filter list that blocks/filters.liquid
// leaves empty, from sections/collection-facets-vertical via the Section Rendering API. Phones
// never load it (they use the filter drawer), so the hidden column no longer costs them thousands
// of DOM nodes before the product grid. On a filter change facets.js fetches the list in the
// same request as the grid and swaps it in (the wrapper skips the section morph, SHO-11729);
// the observer below only refills a list that ended up empty.
import { buildSectionRenderingURL } from '@theme/section-renderer';

const SECTION = 'collection-facets-vertical';
const TOKEN = '__HDS_FACETS_MAIN_SECTION__';
const desktop = window.matchMedia('(min-width: 750px)');
/** @type {WeakMap<HTMLElement, AbortController>} */
const inflight = new WeakMap();

/** @param {HTMLElement} el */
async function fill(el) {
  const key = `${location.pathname}${location.search}`;
  if (el.dataset.loadedKey === key && el.childElementCount) return;
  inflight.get(el)?.abort();
  const ac = new AbortController();
  inflight.set(el, ac);
  try {
    const res = await fetch(buildSectionRenderingURL(SECTION), { signal: ac.signal });
    if (!res.ok) throw new Error(`Vertical facets fetch failed: ${res.status}`);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const section = doc.querySelector('[id^="shopify-section-"]');
    if (!section || ac.signal.aborted || !el.isConnected) return;
    el.innerHTML = section.innerHTML.split(TOKEN).join(el.dataset.mainSectionId || '');
    el.dataset.loadedKey = key;
  } catch (err) {
    if (/** @type {Error} */ (err).name !== 'AbortError') console.error(err);
  } finally {
    if (inflight.get(el) === ac) inflight.delete(el);
  }
}

function fillAll() {
  if (!desktop.matches) return;
  for (const el of document.querySelectorAll('[data-hds-vertical-filters]')) {
    if (el instanceof HTMLElement && !el.childElementCount) fill(el);
  }
}

// Morph replaces the filled list with the empty server placeholder after each filter change.
new MutationObserver(() => fillAll()).observe(document.body, { childList: true, subtree: true });
desktop.addEventListener('change', fillAll);
fillAll();
